import React, { useEffect, useState, useRef } from "react";
import JobCard from "./components/JobCard";
import TalentHeader from "../../components/TalentHeader";
import TalentSideMenu from "../../components/TalentSideMenu";
import { useNavigate } from "react-router-dom";
import CompanyInformationTab from "../talent_job/components/CompanyInformationTab";
import DepartmentMessageTab from "../companyJob/components/DepartmentMessageTab";
import JobInformationTab from "./components/JobInformationTab";
import ConfirmPopup from "../../components/ConfirmPopup";
import { ThunkDispatch } from "@reduxjs/toolkit";
import { useSelector, useDispatch } from "react-redux";
import { useParams } from 'react-router-dom';
import { formatDate, parseTags, renderContentWithTrackedLinks } from "../../utils/format";
import { RECRUITMENT_STATUS, ACTION_TYPE, SYSTEM_USER_NAME } from "../../constants/index";
import CustomToast from "../../components/CustomToast";
import { useSnackbar } from "notistack";
import { LoadingSpinner } from "../../components/Icons";
import {
    setError,
    setSuccess,
    getJobDetail,
    getOtherJobResults,
    updateNumberOfViews,
    sendApplyJob,
    setJobBookmark,
} from "../../reducers/talentJob";
import {
  setChatSelected, setIsSameChatSelected, setIsPaging,
  setIsChatting, setOpenChatListModal,
  setIsScout,
  setJobSelected, setMessages,
  setTalentSelected,
  getDetailTalentChat,
  setStaffSelected, setIsLoadNewListChat,
  getTalentMessages, setIsNewChatFormOtherScreen,
} from "reducers/chatMessage";
import ReturnButton from "../../components/ReturnButton";
import CustomButton from "../../components/CustomButton";
import NotFoundPage from "../../pages/NotFoundPage";
import Copyright from "../../components/Copyright";
import i18n from 'i18next';

const TalentJobDetail = () => {
    const dispatch = useDispatch<ThunkDispatch<any, any, any>>();
    const {chatList} = useSelector((state: any) => state.chatMessage);
    const {
        loading,
        success,
        error,
        actionName,
        actionStatus,
        jobDetailData,
        otherJobResults,
        searchQuery,
        isApplied,
        actionType,
        chatConversation,
        isReloadJobList,
    } = useSelector((state: any) => state.talentJob);
    const navigate = useNavigate();
    const { id } = useParams<{ id: string }>();
    const [isConfirmOpen, setIsConfirmOpen] = useState(false);
    const { enqueueSnackbar, closeSnackbar } = useSnackbar();
    const currentUser = useSelector((state: any) => state.currentUser);
    const jobCardRefs = useRef<(HTMLDivElement | null)[]>([]);
    const [totalHeight, setTotalHeight] = useState(0);

    const [selectedTab, setSelectedTab] = useState({
        label: "概要",
        name: "overview",
    });

    const tabs = [
        {
        label: "概要",
        name: "overview",
        },
        {
        label: "メッセージ",
        name: "department",
        },
        {
        label: "求人詳細",
        name: "related",
        },
    ];

    const clickOnText = () => {
        dispatch(setIsPaging(false));
        dispatch(setIsChatting(true));
        dispatch(setIsNewChatFormOtherScreen(true));
        dispatch(setIsScout(true));
        dispatch(setChatSelected({id: chatConversation, staff_name: SYSTEM_USER_NAME}));
        dispatch(setJobSelected(jobDetailData));
        dispatch(setMessages([]));
        dispatch(getTalentMessages({ id: chatConversation }));
        dispatch(setIsLoadNewListChat(true));
        navigate('/talent/message')
    }

    const showToast = (title: string, message: string, variant: string, textLink: string = "", clickOnText: any = "") => {
        enqueueSnackbar("I love snacks.", {
            content: (key) => (
                <CustomToast title={title} message={message} variant={variant} textLink={textLink} clickOnText={clickOnText} snackbarKey={key} closeSnackbar={closeSnackbar} />
            ),
        });
    };

    const scrollToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: "smooth",
        });
    };

    useEffect(() => {
        if(success){
            if(actionName == "sendApplyJob") showToast(success, i18n.t('MSG_JOB_APPLICATION_SUCCESS'), 'success', 'メッセージを確認', clickOnText);
            else showToast('メッセージ', success, "success");
            dispatch(setSuccess(null));
        }
        else if(error){
            showToast('メッセージ', error, "error");
            dispatch(setError(null));
        }
    }, [error, success]);

    // get max-height to display other items with overflow-y
    useEffect(() => {
        jobCardRefs.current = jobCardRefs.current.slice(0, otherJobResults.length);
    }, [otherJobResults]);

    useEffect(() => {
        if (otherJobResults.length > 5) {
            let height = jobCardRefs.current.slice(0, 5).reduce((acc, ref) => {
                if (ref) {
                    return acc + ref.offsetHeight;
                }
                return acc;
            }, 0);
            height += 16 * 4; // + gap items
            setTotalHeight(height);
        }
    }, [otherJobResults]);

    const getOtherJob = () => {
        if(!id) return;

        const dataOther = {
            id: Number(id),
            search: searchQuery,
        }
        dispatch(getOtherJobResults(dataOther));
    }

    useEffect(() => {
        if(id){
            getOtherJob();
            const data = {
                id: Number(id),
            }
            dispatch(getJobDetail(data));
            const dataUpdate = {
                id: Number(id),
                requestBody: jobDetailData,
            }
            dispatch(updateNumberOfViews(dataUpdate));
            scrollToTop();
        }
    }, [id]);

    if (!jobDetailData || (Array.isArray(jobDetailData) && jobDetailData.length === 0) || Object.keys(jobDetailData).length === 0) {
        if(actionName == "getJobDetail" && actionStatus == "rejected") return <NotFoundPage />;
        return null;
    }

    const jobDetail = {
        ...jobDetailData,
        occupation: jobDetailData.occupation_2?.name,
        location: [
            jobDetailData.location_city?.label,
            jobDetailData.location_village,
            jobDetailData.location_building
        ].filter(Boolean).join(" "),
        salary: "年収 " + `${jobDetailData.annual_salary_min ? `${new Intl.NumberFormat().format(jobDetailData.annual_salary_min)} 万円` : 'ー'}` + " 〜 " + `${jobDetailData.annual_salary_max ? `${new Intl.NumberFormat().format(jobDetailData.annual_salary_max)} 万円` : 'ー'}`,
        salary_general: "年収 " + `${jobDetailData.annual_salary_min ? `${new Intl.NumberFormat().format(jobDetailData.annual_salary_min)} 万円` : 'ー'}` + " 〜 " + `${jobDetailData.annual_salary_max ? `${new Intl.NumberFormat().format(jobDetailData.annual_salary_max)} 万円` : 'ー'}`,
        jobDate: "公開日　" + formatDate(jobDetailData.public_date) + (jobDetailData.expiry_date ? "　〜　募集終了日　" + formatDate(jobDetailData.expiry_date) : ""),
        tag: jobDetailData.tag ? parseTags(String(jobDetailData.tag)) : "",
    }

    const renderTabContent = () => {
        let tabContent;
        if (selectedTab.name === "overview") {
        tabContent = <CompanyInformationTab jobInfomation={jobDetail} />;
        } else if (selectedTab.name === "department") {
        tabContent = <DepartmentMessageTab jobInfomation={jobDetail} />;
        } else {
        tabContent = <JobInformationTab jobInfomation={jobDetail} />;
        }
        return tabContent;
    };

    const handleApplyJob = () => {
        setIsConfirmOpen(true);
    }

    const handleSendApplyJob = () => {
        setIsConfirmOpen(false);
        const data = {
            id: Number(id),
            requestBody: jobDetailData,
        }
        dispatch(sendApplyJob(data));
    }

    const goToChat = (item: any) => {
        dispatch(setIsChatting(true));
        dispatch(setIsNewChatFormOtherScreen(true));
        dispatch(setOpenChatListModal(false));
        dispatch(setIsScout(false));
        dispatch(setStaffSelected({}));
        dispatch(setChatSelected({}));
        if(item.status.value == RECRUITMENT_STATUS.CLOSED || actionType == ACTION_TYPE.SCOUT || actionType == ACTION_TYPE.APPLY) {
            dispatch(setJobSelected({}));
        }
        else {
            item.is_available = true
            dispatch(setJobSelected(item));
        }
        dispatch(setMessages([]));
        if(chatList.length > 0) {
            dispatch(setIsLoadNewListChat(false));
        }
        navigate('/talent/message')
    }

    const goBack = () => {
        dispatch(setIsSameChatSelected(false));
        navigate(-1)
    }

    const handleBookmark = (id) => {
        dispatch(setJobBookmark({id: id, view: "job", requestBody: {}}));
    }

    return (
        <>
        <TalentHeader prevPage={{ name: "求人", path: "", onClick: goBack}} />
        <div className="pb-[125px] md:pb-0 md:mt-4 md:px-2 lg:mt-6 lg:px-6 flex lg:gap-6 md:gap-3 relative max-[324px]:pb-[120px]">
            <div className="w-full md:hidden flex items-center gap-2 px-2 absolute bottom-0 max-[324px]:flex-wrap pb-[73px]">
                <CustomButton
                    type="button"
                    variant="outline"
                    size="md"
                    width="full"
                    customStyle="max-[410px]:px-1 max-[410px]:text-sm"
                    onClick={() => goToChat(jobDetail)}
                >
                    相談する
                </CustomButton>
                <CustomButton
                    disabled={loading || jobDetail.is_disable_apply || isApplied}
                    onClick={() => handleApplyJob()}
                    type="button"
                    size="md"
                    width="full"
                    customStyle="max-[410px]:px-1 max-[410px]:text-sm"
                >
                    今すぐ応募
                </CustomButton>
            </div>
            <div className="md:block">
                <TalentSideMenu />
            </div>
            <div className="flex-1">
                <div className="mb-6 md:flex items-center gap-4 hidden">
                    <ReturnButton onClick={() => goBack()} />
                    <span className="text-sm alu-text-base-1">/</span>
                    <h3 className="text-xl leading-[1.875rem] alu-text-base-2 font-bold">
                    求人情報
                    </h3>
                </div>

                {/* mobile & tablet */}
                <div className="mt-4 md:mt-0 px-4 py-6 h-max bg-white md:hidden rounded md:rounded-2xl alu-section-box-shadow">
                    {actionType && (
                    <p className="mb-2 text-sm font-bold alu-text-title">
                        {actionType == ACTION_TYPE.SCOUT ? "この求人にスカウトされています。": "この求人に応募しています。"}
                    </p>
                    )}
                    <p className="text-2xl font-bold alu-text-base-2 mb-4">
                        {jobDetail.title}
                    </p>
                    {jobDetail.tag && (
                    <div className="mb-2 flex flex-wrap items-center gap-2">
                    {jobDetail?.tag.map((item: any, idx: number) => (
                        <span
                        key={idx}
                        className="border border-[#808080] rounded flex items-center justify-center py-[0.125rem] px-[0.375rem] text-xs font-normal alu-text-base-1"
                        >
                        {item}
                        </span>
                    ))}
                    </div>
                    )}
                    <div className="mb-2 flex items-center gap-4">
                        <div className="flex items-center gap-2 alu-text-base-2">
                            <span>
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                            <mask id="mask0_18055_10422" style={{ maskType: "alpha" }} maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24">
                                <rect width="24" height="24" fill="#D9D9D9"/>
                            </mask>
                            <g mask="url(#mask0_18055_10422)">
                                <path d="M1 20V17.2C1 16.6333 1.14583 16.1125 1.4375 15.6375C1.72917 15.1625 2.11667 14.8 2.6 14.55C3.63333 14.0333 4.68333 13.6458 5.75 13.3875C6.81667 13.1292 7.9 13 9 13C10.1 13 11.1833 13.1292 12.25 13.3875C13.3167 13.6458 14.3667 14.0333 15.4 14.55C15.8833 14.8 16.2708 15.1625 16.5625 15.6375C16.8542 16.1125 17 16.6333 17 17.2V20H1ZM19 20V17C19 16.2667 18.7958 15.5625 18.3875 14.8875C17.9792 14.2125 17.4 13.6333 16.65 13.15C17.5 13.25 18.3 13.4208 19.05 13.6625C19.8 13.9042 20.5 14.2 21.15 14.55C21.75 14.8833 22.2083 15.2542 22.525 15.6625C22.8417 16.0708 23 16.5167 23 17V20H19ZM9 12C7.9 12 6.95833 11.6083 6.175 10.825C5.39167 10.0417 5 9.1 5 8C5 6.9 5.39167 5.95833 6.175 5.175C6.95833 4.39167 7.9 4 9 4C10.1 4 11.0417 4.39167 11.825 5.175C12.6083 5.95833 13 6.9 13 8C13 9.1 12.6083 10.0417 11.825 10.825C11.0417 11.6083 10.1 12 9 12ZM19 8C19 9.1 18.6083 10.0417 17.825 10.825C17.0417 11.6083 16.1 12 15 12C14.8167 12 14.5833 11.9792 14.3 11.9375C14.0167 11.8958 13.7833 11.85 13.6 11.8C14.05 11.2667 14.3958 10.675 14.6375 10.025C14.8792 9.375 15 8.7 15 8C15 7.3 14.8792 6.625 14.6375 5.975C14.3958 5.325 14.05 4.73333 13.6 4.2C13.8333 4.11667 14.0667 4.0625 14.3 4.0375C14.5333 4.0125 14.7667 4 15 4C16.1 4 17.0417 4.39167 17.825 5.175C18.6083 5.95833 19 6.9 19 8Z" fill="#808080"/>
                            </g>
                            </svg>
                            </span>
                            <p className="text-base alu-text-base-2 w-[54px]">部署</p>
                        </div>
                        <p className="text-base alu-text-base-2">{jobDetail.department || 'ー'}</p>
                    </div>
                    <div className="mb-2 flex items-center gap-4">
                        <div className="flex items-center gap-2 alu-text-base-2">
                            <span>
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                            <mask id="mask0_18055_13916" style={{ maskType: "alpha" }} maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24">
                                <rect width="24" height="24" fill="#D9D9D9"/>
                            </mask>
                            <g mask="url(#mask0_18055_13916)">
                                <path d="M4 21C3.45 21 2.97917 20.8042 2.5875 20.4125C2.19583 20.0208 2 19.55 2 19V8C2 7.45 2.19583 6.97917 2.5875 6.5875C2.97917 6.19583 3.45 6 4 6H8V4C8 3.45 8.19583 2.97917 8.5875 2.5875C8.97917 2.19583 9.45 2 10 2H14C14.55 2 15.0208 2.19583 15.4125 2.5875C15.8042 2.97917 16 3.45 16 4V6H20C20.55 6 21.0208 6.19583 21.4125 6.5875C21.8042 6.97917 22 7.45 22 8V19C22 19.55 21.8042 20.0208 21.4125 20.4125C21.0208 20.8042 20.55 21 20 21H4ZM10 6H14V4H10V6Z" fill="#808080"/>
                            </g>
                            </svg>
                            </span>
                            <p className="text-base alu-text-base-2 w-[54px]">職種</p>
                        </div>
                        <p className="text-base alu-text-base-2">{jobDetail.occupation}</p>
                    </div>
                    <div className="mb-2 flex items-center gap-4">
                        <div className="flex items-center gap-2">
                            <span>
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                                fill="none"
                            >
                                <mask
                                id="mask0_14003_28221"
                                style={{ maskType: "alpha" }}
                                maskUnits="userSpaceOnUse"
                                x="0"
                                y="0"
                                width="24"
                                height="24"
                                >
                                <rect width="24" height="24" fill="#D9D9D9" />
                                </mask>
                                <g mask="url(#mask0_14003_28221)">
                                <path
                                    d="M3 21V7H7V3H17V11H21V21H13V17H11V21H3ZM5 19H7V17H5V19ZM5 15H7V13H5V15ZM5 11H7V9H5V11ZM9 15H11V13H9V15ZM9 11H11V9H9V11ZM9 7H11V5H9V7ZM13 15H15V13H13V15ZM13 11H15V9H13V11ZM13 7H15V5H13V7ZM17 19H19V17H17V19ZM17 15H19V13H17V15Z"
                                    fill="#1C1B1F"
                                />
                                </g>
                            </svg>
                            </span>
                            <p className="text-base alu-text-base-2 w-[54px]">勤務地</p>
                        </div>
                        <p className="text-base alu-text-base-2">{jobDetail.location}</p>
                    </div>
                    <div className="mb-2 flex gap-4">
                        <div className="flex gap-2">
                            <span>
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                                fill="none"
                            >
                                <mask
                                id="mask0_14003_28228"
                                style={{ maskType: "alpha" }}
                                maskUnits="userSpaceOnUse"
                                x="0"
                                y="0"
                                width="24"
                                height="24"
                                >
                                <rect width="24" height="24" fill="#D9D9D9" />
                                </mask>
                                <g mask="url(#mask0_14003_28228)">
                                <path
                                    fillRule="evenodd"
                                    clipRule="evenodd"
                                    d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22ZM11.2857 16V18.8571H12.7143V16H16.2857V14.5714H12.7143V13.1429H16.2857V11.7143H13.375L17 6H15.3036L12 11.2143L8.69643 6H7L10.625 11.7143H7.71429V13.1429H11.2857V14.5714H7.71429V16H11.2857Z"
                                    fill="#343A3D"
                                />
                                </g>
                            </svg>
                            </span>
                            <p className="text-base alu-text-base-2 w-[54px]">給与</p>
                        </div>
                        <p className="text-base alu-text-base-2">{jobDetail.salary_general || 'ー'}</p>
                    </div>
                    <p className="text-sm alu-text-base-1 font-normal">
                        {jobDetail.jobDate}
                    </p>
                    <div className="mt-10 mb-6 flex items-center gap-2">
                    {tabs.map((tab, idx) => (
                        <div
                        onClick={() => setSelectedTab(tab)}
                        key={idx}
                        className={`px-2 py-1 text-center flex-1 ${
                            tab.name === selectedTab.name
                            ? "alu-text-base-2 font-bold border-b-2 border-[#343A3D]"
                            : "alu-text-base-1 font-normal"
                        } text-sm`}
                        >
                        {tab.label}
                        </div>
                    ))}
                    </div>
                    {renderTabContent()}
                </div>

                {/* desktop */}
                <div className="hidden md:flex md:gap-3 lg:gap-6">
                    <div className="w-full pb-6 pt-8 rounded-2xl bg-white h-max alu-section-box-shadow mb-6">
                    <div className="px-6 mb-6">
                        {actionType && (
                        <p className="mb-4 text-sm font-bold alu-text-title">
                            {actionType == ACTION_TYPE.SCOUT ? "この求人にスカウトされています。": "この求人に応募しています。"}
                        </p>
                        )}
                        <h2
                        className="mb-4 text-2xl font-bold alu-text-base-2"
                        >
                            {jobDetail.title}
                        </h2>
                        {jobDetail.tag && (
                        <div className="flex flex-wrap items-center gap-2 mb-4 mt-2">
                        {jobDetail?.tag.map((tag: any, idx: any) => (
                            <span
                            key={idx}
                            className="px-2 py-[0.125rem] rounded border bg-white border-[#808080] text-xs text-center"
                            >
                            {tag}
                            </span>
                        ))}
                        </div>
                        )}
                        <div className="flex flex-col gap-2 mb-4">
                            <div className="flex items-center gap-[1.125rem]">
                                <div className="min-w-[80px] flex items-center">
                                    <span className="mr-1">
                                        <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="24"
                                        height="24"
                                        viewBox="0 0 24 24"
                                        fill="none"
                                        >
                                        <mask
                                            id="mask0_13672_2581"
                                            style={{ maskType: "alpha" }}
                                            maskUnits="userSpaceOnUse"
                                            x="0"
                                            y="0"
                                            width="24"
                                            height="24"
                                        >
                                            <rect width="24" height="24" fill="#D9D9D9" />
                                        </mask>
                                        <g mask="url(#mask0_13672_2581)">
                                            <path
                                            d="M1 20V17.2C1 16.6333 1.14583 16.1125 1.4375 15.6375C1.72917 15.1625 2.11667 14.8 2.6 14.55C3.63333 14.0333 4.68333 13.6458 5.75 13.3875C6.81667 13.1292 7.9 13 9 13C10.1 13 11.1833 13.1292 12.25 13.3875C13.3167 13.6458 14.3667 14.0333 15.4 14.55C15.8833 14.8 16.2708 15.1625 16.5625 15.6375C16.8542 16.1125 17 16.6333 17 17.2V20H1ZM19 20V17C19 16.2667 18.7958 15.5625 18.3875 14.8875C17.9792 14.2125 17.4 13.6333 16.65 13.15C17.5 13.25 18.3 13.4208 19.05 13.6625C19.8 13.9042 20.5 14.2 21.15 14.55C21.75 14.8833 22.2083 15.2542 22.525 15.6625C22.8417 16.0708 23 16.5167 23 17V20H19ZM9 12C7.9 12 6.95833 11.6083 6.175 10.825C5.39167 10.0417 5 9.1 5 8C5 6.9 5.39167 5.95833 6.175 5.175C6.95833 4.39167 7.9 4 9 4C10.1 4 11.0417 4.39167 11.825 5.175C12.6083 5.95833 13 6.9 13 8C13 9.1 12.6083 10.0417 11.825 10.825C11.0417 11.6083 10.1 12 9 12ZM19 8C19 9.1 18.6083 10.0417 17.825 10.825C17.0417 11.6083 16.1 12 15 12C14.8167 12 14.5833 11.9792 14.3 11.9375C14.0167 11.8958 13.7833 11.85 13.6 11.8C14.05 11.2667 14.3958 10.675 14.6375 10.025C14.8792 9.375 15 8.7 15 8C15 7.3 14.8792 6.625 14.6375 5.975C14.3958 5.325 14.05 4.73333 13.6 4.2C13.8333 4.11667 14.0667 4.0625 14.3 4.0375C14.5333 4.0125 14.7667 4 15 4C16.1 4 17.0417 4.39167 17.825 5.175C18.6083 5.95833 19 6.9 19 8Z"
                                            fill="#808080"
                                            />
                                        </g>
                                        </svg>
                                    </span>
                                    <p className="text-base alu-text-base-2">部署</p>
                                </div>
                                <p className="text-base alu-text-base-2">{jobDetail.department || 'ー'}</p>
                            </div>
                            <div className="flex items-center gap-[1.125rem]">
                                <div className="min-w-[80px] flex items-center">
                                    <span className="mr-1">
                                        <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="24"
                                        height="24"
                                        viewBox="0 0 24 24"
                                        fill="none"
                                        >
                                        <mask
                                            id="mask0_13672_12413"
                                            style={{ maskType: "alpha" }}
                                            maskUnits="userSpaceOnUse"
                                            x="0"
                                            y="0"
                                            width="24"
                                            height="24"
                                        >
                                            <rect width="24" height="24" fill="#D9D9D9" />
                                        </mask>
                                        <g mask="url(#mask0_13672_12413)">
                                            <path
                                            d="M4 21C3.45 21 2.97917 20.8042 2.5875 20.4125C2.19583 20.0208 2 19.55 2 19V8C2 7.45 2.19583 6.97917 2.5875 6.5875C2.97917 6.19583 3.45 6 4 6H8V4C8 3.45 8.19583 2.97917 8.5875 2.5875C8.97917 2.19583 9.45 2 10 2H14C14.55 2 15.0208 2.19583 15.4125 2.5875C15.8042 2.97917 16 3.45 16 4V6H20C20.55 6 21.0208 6.19583 21.4125 6.5875C21.8042 6.97917 22 7.45 22 8V19C22 19.55 21.8042 20.0208 21.4125 20.4125C21.0208 20.8042 20.55 21 20 21H4ZM10 6H14V4H10V6Z"
                                            fill="#808080"
                                            />
                                        </g>
                                        </svg>
                                    </span>
                                    <p className="text-base alu-text-base-2">職種</p>
                                </div>
                                <p className="text-base alu-text-base-2">{jobDetail.occupation}</p>
                            </div>
                            <div className="flex items-center gap-[1.125rem]">
                                <div className="min-w-[80px] flex items-center">
                                    <span className="mr-1">
                                        <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="24"
                                        height="24"
                                        viewBox="0 0 24 24"
                                        fill="none"
                                        >
                                        <mask
                                            id="mask0_11508_17889"
                                            style={{ maskType: "alpha" }}
                                            maskUnits="userSpaceOnUse"
                                            x="0"
                                            y="0"
                                            width="24"
                                            height="24"
                                        >
                                            <rect width="24" height="24" fill="#D9D9D9" />
                                        </mask>
                                        <g mask="url(#mask0_11508_17889)">
                                            <path
                                            d="M3 21V7H7V3H17V11H21V21H13V17H11V21H3ZM5 19H7V17H5V19ZM5 15H7V13H5V15ZM5 11H7V9H5V11ZM9 15H11V13H9V15ZM9 11H11V9H9V11ZM9 7H11V5H9V7ZM13 15H15V13H13V15ZM13 11H15V9H13V11ZM13 7H15V5H13V7ZM17 19H19V17H17V19ZM17 15H19V13H17V15Z"
                                            fill="#808080"
                                            />
                                        </g>
                                        </svg>
                                    </span>
                                    <p className="text-base alu-text-base-2">勤務地</p>
                                </div>
                                <p className="text-base alu-text-base-2">
                                    {jobDetail.location}
                                </p>
                            </div>
                            <div className="flex items-center gap-[1.125rem]">
                                <div className="min-w-[80px] flex items-center">
                                    <span className="mr-1">
                                        <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="24"
                                        height="24"
                                        viewBox="0 0 24 24"
                                        fill="none"
                                        >
                                        <mask
                                            id="mask0_11508_17894"
                                            style={{ maskType: "alpha" }}
                                            maskUnits="userSpaceOnUse"
                                            x="0"
                                            y="0"
                                            width="24"
                                            height="24"
                                        >
                                            <rect width="24" height="24" fill="#D9D9D9" />
                                        </mask>
                                        <g mask="url(#mask0_11508_17894)">
                                            <path
                                            fillRule="evenodd"
                                            clipRule="evenodd"
                                            d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22ZM11.2857 16V18.8571H12.7143V16H16.2857V14.5714H12.7143V13.1429H16.2857V11.7143H13.375L17 6H15.3036L12 11.2143L8.69643 6H7L10.625 11.7143H7.71429V13.1429H11.2857V14.5714H7.71429V16H11.2857Z"
                                            fill="#808080"
                                            />
                                        </g>
                                        </svg>
                                    </span>
                                    <p className="text-base alu-text-base-2">給与</p>
                                </div>
                                <p className="text-base alu-text-base-2">
                                    {jobDetail.salary || 'ー'}
                                </p>
                            </div>
                        </div>
                        <p className="text-sm alu-text-base-1 font-normal">
                            {jobDetail.jobDate}
                        </p>
                    </div>

                    <div className="px-6 mb-6">
                        <div className="w-full h-[1px] bg-[#E0E0E0]"></div>
                    </div>

                    <p className="px-6 text-sm font-normal alu-text-base-2 whitespace-pre-wrap break-all mb-8">
                        {renderContentWithTrackedLinks(jobDetail.message_from_department)}
                    </p>

                    <div className="px-6 mb-8">
                        <CompanyInformationTab jobInfomation={jobDetail} />
                    </div>

                    <div className="px-6">
                        <JobInformationTab jobInfomation={jobDetail} />
                    </div>
                    </div>

                    <div className="hidden md:block md:min-w-[200px] lg:shrink-0 w-[260px] xl:w-[320px]">
                    <CustomButton
                        disabled={loading || jobDetail.is_disable_apply || isApplied}
                        onClick={() => handleApplyJob()}
                        type="button"
                        size="md"
                        width="full"
                        customStyle="mb-2"
                    >
                        <p>{loading ? "保存中..." : "今すぐ応募"}</p>
                        {loading && (
                            <span><LoadingSpinner /></span>
                        )}
                    </CustomButton>
                    <CustomButton
                        type="button"
                        width="full"
                        variant="outline"
                        size="md"
                        customStyle="mb-4"
                        onClick={() => goToChat(jobDetail)}
                    >
                        相談する
                    </CustomButton>
                    <div onClick={() => handleBookmark(jobDetail.id)} className="hidden mb-4 py-1 px-2 lg:flex items-center gap-1 hover:bg-[#FFF3E5] cursor-pointer w-fit rounded">
                        <button>
                            {!jobDetail.is_bookmarked ? 
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                <g clipPath="url(#clip0_11236_7241)">
                                <path d="M17 3H7C5.9 3 5.01 3.9 5.01 5L5 21L12 18L19 21V5C19 3.9 18.1 3 17 3ZM17 18L12 15.82L7 18V5H17V18Z" fill="#FF861A"/>
                                </g>
                                <defs>
                                <clipPath id="clip0_11236_7241">
                                    <rect width="24" height="24" fill="white"/>
                                </clipPath>
                                </defs>
                            </svg> : 
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                <g clipPath="url(#clip0_11236_7249)">
                                <path d="M17 3H7C5.9 3 5.01 3.9 5.01 5L5 21L12 18L19 21V5C19 3.9 18.1 3 17 3Z" fill="#FF861A"/>
                                </g>
                                <defs>
                                <clipPath id="clip0_11236_7249">
                                    <rect width="24" height="24" fill="white"/>
                                </clipPath>
                                </defs>
                            </svg>}
                        </button>
                        <p
                        className={`text-sm text-[#FF861A]`}
                        >
                        {!jobDetail.is_bookmarked ? 'この記事をブックマーク' : 'ブックマーク済み'}
                        </p>
                    </div>
                    {otherJobResults?.length > 0 && (
                    <>
                    <h5 className="mb-2 text-xl alu-text-base-2 font-bold xl:text-base">
                        {searchQuery ? "その他の検索結果" : "関連記事"}
                    </h5>
                    <div
                        className={`flex flex-col gap-4 mb-4 ${otherJobResults.length > 5 ? 'overflow-y-auto custom-scrollbar' : ''}`}
                        style={{
                          maxHeight: otherJobResults.length > 5 ? `${totalHeight}px` : 'none',
                        }}
                    >
                        {otherJobResults.map((item: any, idx: number) => (
                        <div
                            key={idx}
                            ref={(el) => (jobCardRefs.current[idx] = el)}
                        >
                            <JobCard key={idx} items={item} />
                        </div>
                        ))}
                    </div>
                    </>
                    )}
                    </div>
                </div>
            </div>
        </div>
        {isConfirmOpen && (
            <ConfirmPopup
            open={isConfirmOpen}
            onClose={() => setIsConfirmOpen(false)}
            confirmContent={
                <>
                    <p>
                    {jobDetail?.title} に応募します。
                    <br />
                    よろしいでしょうか？
                    </p>
                </>
            }
            onConfirm={handleSendApplyJob}
            cancelText="キャンセル"
            confirmText="OK"
            />
        )}
        <div className="hidden md:block">
            <Copyright view="talent" />
        </div>
        </>
    );
};

export default TalentJobDetail;
